import { useQuery } from '@tanstack/react-query';
import { Skeleton, Typography } from '@volvo/vcdk-react';
import React from 'react';

import type { TypographyVariant } from '@volvo/vcdk';

import { getFleetUnitsCountQueryOptions } from '@/service/vpc/queryOptions';

type Props = {
  fleetId: string;
  variant: TypographyVariant;
  unit?: string;
  className?: string;
};

const FleetUnitCount: React.FC<Props> = ({ fleetId, variant, unit, className }) => {
  const { data: count, isLoading } = useQuery(getFleetUnitsCountQueryOptions({ fleetId }));

  if (isLoading) {
    return <Skeleton typographyVariant={variant} width={60} />;
  }
  return (
    <Typography variant={variant} className={className}>
      {count} {unit}
    </Typography>
  );
};

export default FleetUnitCount;
